/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Favorite from "@material-ui/icons/Favorite";

import KisetsuNavbar from "components/Header/KisetsuNavbar";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";

import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
import SectionServices from "views/AboutUsPage/Sections/SectionServices.js";
import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";
import SectionContact from "views/AboutUsPage/Sections/SectionContact.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import SectionGallery from "./Sections/SectionGallery";

const useStyles = makeStyles(aboutUsStyle);

export default function AboutUsPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  const classes = useStyles();

  return (
    <div>
      <KisetsuNavbar />
      <Parallax image={require("assets/img/sonbahar-Photoroom.jpg")} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <h1 className={classes.title}>Hakkımızda</h1>
              <h4>
                Bu projeyi hayata geçiren harika ekibimizi tanıyın ve nasıl
                çalıştığımızı keşfedin. Estetik, kalite ve işlevselliği bir
                araya getirerek ajandayı bir yaşam tarzına dönüştürüyoruz.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          {/* <SectionDescription /> */}
          <SectionTeam />
          <SectionServices />
          {/* <SectionOffice /> */}
          <SectionGallery />
          {/* <SectionContact /> */}
        </div>
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="/blog-posts" className={classes.block}>Blog</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/about-us" className={classes.block}>Hakkımızda</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/products" className={classes.block}>Mağaza</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/contact-us" className={classes.block}>İletişim</a>
            </ListItem>
          </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , sevgiyle tasarlandı{" "}
              <Favorite className={classes.icon} />{" "}
              <a href="/" target="_blank" rel="noopener noreferrer">
                Kisetsu
              </a>{" "}
              ile daha düzenli bir hayat için.
            </div>
          </div>
        }
      />
    </div>
  );
}
